import type { FaireProductEntity } from "../../entity_types/product";

export const p_2v1cbpnk2a: FaireProductEntity = {
  token: "p_2v1cbpnk2a",
  type: "product",
  name: "Organic Fruit Bites: Mango & Coconut, 8-pack case",
  brandToken: "b_3suuhjvzxi",
  brandName: "Mavuno Harvest Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/63d8082d0b0fcda048a52f1e53e11fa0b5de798b2ae943f24382abd9292588d4.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f8fc4c0408cc80a3356110f40da7b4ccac5ac560c6574f7925f2df5c04973e87.png",
    "https://cdn.faire.com/fastly/7cc3059b45674a7d5e92103c71f7050265ae1c5d59783739d828ff8df8a13418.png",
    "https://cdn.faire.com/fastly/ce28f4aca5e9f075405a0f33700195633e63ac732be08da5bd18cf4acce6d2a1.png",
  ],
  priceDollars: 22.16,
  description:
    "Chewy, Sweet, and Perfectly Tropical\n\n\n\nThese bite-sized snacks blend juicy mango with chewy coconut for a simple, wholesome treat that’s just the right mix of sweet and satisfying.\n\n\n\nIngredients\n\n\n\n * Organic mango \n * Organic coconut \n * No preservatives \n * No added sugar \nWhy It Matters\n\n\nMade with fruit sourced from Ghana, our bites support small farmers while giving you a snack that’s as good for the planet as it is for you.\n",
  tags: [],
  msrpDollars: 37.4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:48:32.184Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
